import React, { useEffect } from 'react';
import isNil from 'lodash-es/isNil';

import { useMediaPlayer } from './MediaPlayerProvider';

export const Poster: React.FC<{ imgSrc: string }> = ({ imgSrc }) => {
  const { player } = useMediaPlayer();

  useEffect(() => {
    if (player !== null) {
      const isImageSrcProvided = !isNil(imgSrc);
      if (!isImageSrcProvided) {
        player.poster('');
      } else {
        const isDifferentImage = player.poster() !== imgSrc;
        if (isDifferentImage) {
          player.poster(imgSrc);
        }
      }
    }
  }, [player, imgSrc]);

  return null;
};
